<ng-container *ngIf="pageReady && authenticated">    
    <div class="compact padded">    
        <div class="page">
            <div class="page-left">
                <div class="simplemenu">
                    <ul>
                        <li *ngFor="let p of pagesAcc"><a [routerLink]="'/'+currentLang.slug+'/account/'+p.slug">{{p.name[currentLang.slug]}}</a></li>
                    </ul>
                </div>
                <div class="slidemenu">
                    <slide-menu [head]="page.name[currentLang.slug]" urlprefix="account" [pages]="pagesAcc"></slide-menu>
                </div>
            </div>
            <div class="page-right">
                <div id="breadcrumbs">
                    <span><a routerLink="/{{currentLang.defended ? '' : currentLang.slug}}">{{currentLang.s['common']['home']}}</a></span>            
                </div>        
                <h1 [innerHTML]="page.h1[currentLang.slug] || page.name[currentLang.slug]"></h1>
                <div class="userdata">
                    <form (submit)="update();">
                        <div class="ud-content">                            
                            <div class="ud-item colspan2">
                                <label>{{currentLang.s['user']['phone']}}</label>
                                <div class="udi-inputwrap"><input type="text" name="phone" [(ngModel)]="user.phone"></div>                                
                            </div>
                            <div class="ud-item">
                                <label>{{currentLang.s['user']['address']}}</label>
                                <div class="udi-inputwrap"><input type="text" name="address" [(ngModel)]="user.address"></div>                                
                            </div>
                            <div class="ud-item">
                                <label>{{currentLang.s['user']['city']}}</label>
                                <div class="udi-inputwrap"><input type="text" name="city" [(ngModel)]="user.city"></div>                                
                            </div>
                            <div class="ud-item">
                                <label>{{currentLang.s['user']['province']}}</label>
                                <div class="udi-inputwrap"><input type="text" name="province" [(ngModel)]="user.province"></div>                                
                            </div>
                            <div class="ud-item">
                                <label>{{currentLang.s['user']['country']}}</label>
                                <div class="udi-selectwrap">
                                    <select [(ngModel)]="user.country_id" name="country_id">
                                        <option [ngValue]="null"></option>
                                        <option *ngFor="let c of countries" [ngValue]="c.id">{{c.name[currentLang.slug]}}</option>
                                    </select>
                                </div>                                
                            </div>
                        </div>
                        <div class="ud-btnwrap topmargined"><button type="submit" [disabled]="formLoading">{{currentLang.s['common']['save']}}</button></div>
                        <div class="ud-msg" [innerHTML]="formMsg" [class.error]="formError"></div>                                                
                    </form>                        
                </div>            
            </div>        
        </div>            
    </div>        
</ng-container>
